import React from 'react';
import AnnotationLayerContext from "../contexts/AnnotationContext.js";

var useAnnotationContext = function useAnnotationContext() {
  var layer = React.useContext(AnnotationLayerContext);

  if (!layer) {
    throw new Error('annotation context provider not found');
  }

  return layer;
};

export default useAnnotationContext;